import React from 'react';
import { ConnectComponentsProvider } from '@stripe/react-connect-js';
import { EmbeddedComponentProvider } from './EmbeddedComponentProvider';
import { useStripeConnect } from './useStripeConnect';
import { CSpinner } from '@coreui/react';

export const EmbeddedComponentWrapper = ({ children, accountId }) => {
  const { hasError, stripeConnectInstance } = useStripeConnect(accountId);

  console.log('EmbeddedComponentWrapper render:', {
    hasInstance: !!stripeConnectInstance,
    methods: stripeConnectInstance ? Object.getOwnPropertyNames(stripeConnectInstance) : [],
    prototype: stripeConnectInstance ? Object.getOwnPropertyNames(Object.getPrototypeOf(stripeConnectInstance)) : [],
    accountId
  });

  // Don't show loading state if we don't have an accountId yet
  if (!accountId) {
    return <>{children}</>;
  }

  if (hasError) {
    return (
      <div className="text-center">
        <p className="text-danger">Failed to load Stripe Connect</p>
      </div>
    );
  }

  if (!stripeConnectInstance) {
    return (
      <div className="text-center">
        <CSpinner />
      </div>
    );
  }

  return (
    <ConnectComponentsProvider 
      connectInstance={stripeConnectInstance}
      publishableKey={import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY}
      account={accountId}
      options={{
        stripeAccount: accountId
      }}
    >
      <EmbeddedComponentProvider connectInstance={stripeConnectInstance}>
        {children}
      </EmbeddedComponentProvider>
    </ConnectComponentsProvider>
  );
}; 